import PropTypes from "prop-types";
import CanvasIcon from "./CanvasIcon";
import { fillTemplate, WORKSHOP_ICONS } from "./workshop-view";

const WorkshopCode = ({
  labels,
  value,
  hasScreen,
  isState,
  targetName,
  disabled,
  onChange,
  onSave,
  tools,
}) => (
  <div className="workshop-code-view">
    <div className="workshop-code-view__bar">
      <span className="workshop-code-view__hint">
        {hasScreen
          ? fillTemplate(labels.HINT, { target: targetName })
          : labels.HINT_NEW}
      </span>
      <button
        type="button"
        className="workshop-button workshop-button--primary workshop-button--small"
        disabled={disabled}
        onClick={onSave}
      >
        <CanvasIcon path={WORKSHOP_ICONS.check} size={16} strokeWidth={2.2} />
        {hasScreen ? labels.SAVE : labels.CREATE}
      </button>
      {tools}
    </div>
    <div className="workshop-code">
      <section className="workshop-code__pane">
        <div className="workshop-code__head">
          <strong>{labels.HTML}</strong>
          <span>{hasScreen ? targetName : labels.HTML_NEW}</span>
        </div>
        <textarea
          wrap="off"
          spellCheck={false}
          aria-label={labels.HTML_LABEL}
          placeholder={labels.HTML_PLACEHOLDER}
          value={value.html}
          onChange={(event) => onChange({ ...value, html: event.target.value })}
        />
      </section>
      {isState ? (
        <div className="workshop-code__note">
          <CanvasIcon path={WORKSHOP_ICONS.info} size={16} />
          <span>{labels.STATE_NOTE}</span>
        </div>
      ) : (
        <section className="workshop-code__pane">
          <div className="workshop-code__head">
            <strong>{labels.CSS}</strong>
            <span>{labels.CSS_NOTE}</span>
          </div>
          <textarea
            wrap="off"
            spellCheck={false}
            aria-label={labels.CSS_LABEL}
            placeholder={labels.CSS_PLACEHOLDER}
            value={value.css}
            onChange={(event) =>
              onChange({ ...value, css: event.target.value })
            }
          />
        </section>
      )}
    </div>
  </div>
);

WorkshopCode.propTypes = {
  labels: PropTypes.object.isRequired,
  value: PropTypes.shape({ html: PropTypes.string, css: PropTypes.string })
    .isRequired,
  hasScreen: PropTypes.bool,
  isState: PropTypes.bool,
  targetName: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  tools: PropTypes.node,
};

WorkshopCode.defaultProps = {
  hasScreen: false,
  isState: false,
  targetName: "",
  disabled: false,
  tools: null,
};

export default WorkshopCode;
